'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import { YourResumeScoreWrapper, LeftSide, RightSide, Content, ContentTitle, DescriptionText, Action } from './YourResumeScore.css.js';
import CircleProgressBar from '../CircleProgressBar/index.js';
import Button from '../Button/index.js';
import translations from './translations.js';
import { apiGetResumeScore } from './service.js';

var YourResumeScore = function (props) {
    var langCode = props.langCode, jobId = props.jobId, accessToken = props.accessToken, apiGetScore = props.apiGetScore;
    var _a = useState(0), score = _a[0], setScore = _a[1];
    var t = function (text) {
        var _a;
        if (langCode === 'en') {
            return text;
        }
        else {
            return (_a = translations[text]) !== null && _a !== void 0 ? _a : text;
        }
    };
    var onClick = function () {
        window.open("".concat(t('/track-my-competitive-rate/')).concat(jobId), '_blank');
    };
    var getResumeScore = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, apiGetResumeScore(jobId, apiGetScore, accessToken, langCode)];
                case 1:
                    response = _c.sent();
                    if ((_a = response === null || response === void 0 ? void 0 : response.result) === null || _a === void 0 ? void 0 : _a.score) {
                        setScore((_b = response === null || response === void 0 ? void 0 : response.result) === null || _b === void 0 ? void 0 : _b.score);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getResumeScore();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React__default.createElement(YourResumeScoreWrapper, null,
        React__default.createElement(LeftSide, null,
            React__default.createElement(CircleProgressBar, { percent: score, options: {
                    color: '#6FB920'
                } })),
        React__default.createElement(RightSide, null,
            React__default.createElement(Content, null,
                React__default.createElement(ContentTitle, null, t('Competitive rate')),
                React__default.createElement(DescriptionText, null, t('Analyzed using your application profile compared to other candidates applying for this job.'))),
            React__default.createElement(Action, null,
                React__default.createElement(Button, { type: 'primary', onClick: onClick }, t('View stats'))))));
};

export { YourResumeScore as default };
//# sourceMappingURL=index.js.map
